import { BaseResource } from "./BaseResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class CarOrderDetailsResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.avaiableDrivers = [];
    }
    pk() {
        return this.applicationId?.toString();
    }
}
CarOrderDetailsResource.urlRoot = legacyApiResourceUrl("CarOrder/Details");
export { CarOrderDetailsResource };
//# sourceMappingURL=CarOrderResources.js.map